import get from "lodash/get";

export const getActiveUserIds = state => get(state, "activeUsers.active");
export const getActiveUsersLoaded = state => get(state, "activeUsers.loaded");
